import {
  baseOmegaApi,
  type OmegaApiResponse
} from '@shared/api';

export type ReferralLink = {
  referralLink: Url;
  referralCode: string;
};

export type GetReferralLinksResponse = OmegaApiResponse & {
  referralLinks: Array<ReferralLink>;
};

export const referralLinksSlice = baseOmegaApi.injectEndpoints({
  endpoints: build => ({
    getReferralLinks: build.query<GetReferralLinksResponse, void>({
      query: () => ({ url: '/ips/getReferralLinks' }),
      extraOptions: { showLoader: false, auth: true },
    }),
  }),
});

export const { useGetReferralLinksQuery } = referralLinksSlice;
